import React from 'react';
import Paper from "@material-ui/core/Paper";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {Divider} from "@material-ui/core";
import {CALENDAR_ES} from "../../utils/constants/Constants";

const EdicionPosturaView = (props) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '2%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <h1>Edición Postura</h1>
                Captura los datos requeridos en los filtros y pulsa el botón de buscar

                <Divider/>
                <div className="p-grid">
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Emisora</h3>

                        <Dropdown name="emisora"
                                  options={props.emisoras}
                                  value={props.emisora}
                                  onChange={props.handleChangeText}
                                  placeholder="Seleccione una emisora"
                                  optionLabel="name"/>


                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Cantidad</h3>
                        <InputText name="cantidad"
                                   value={props.cantidad}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Precio</h3>
                        <InputText name="precio"
                                   value={props.precio}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Total</h3>
                        <InputText name="total"
                                   value={props.total}
                                   onChange={props.handleChangeText}/>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Premio</h3>
                        <InputText name="premio"
                                   value={props.premio}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Tipo de aforo</h3>
                        <InputText name="tipoAforo"
                                   value={props.tipoAforo}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-6"/>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Plazo</h3>
                        <InputText name="plazo"
                                   value={props.plazo}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Tasa</h3>
                        <InputText name="tasa"
                                   value={props.tasa}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Sobretasa</h3>
                        <InputText name="sobretasa"
                                   value={props.sobretasa}
                                   onChange={props.handleChangeText}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <h3 className="first">Plazo mínimo</h3>
                        <InputText name="plazoMin"
                                   value={props.plazoMin}
                                   onChange={props.handleChangeText}/>
                    </div>

                    <div className="p-col-12">
                        <h3 className="first">Fecha valor</h3>
                        <Calendar name="fechaValor"
                                  showIcon={true}
                                  value={props.fechaValor}
                                  onChange={props.handleChangeText}
                                  monthNavigator={true}
                                  yearNavigator={true}
                                  yearRange={CALENDAR_ES['yearRange']}
                                  locale={CALENDAR_ES}
                                  showButtonBar={true}/>
                    </div>

                    <div className="p-col-12">
                        <b>Valores aceptados: </b>
                        EF Efectivo, IS Bpas, IT Bpat, LP, Acciones, Bonos M, udibonos, Cetes
                    </div>
                    <div className="p-col-12" align="right">
                        <Button label="Cancelar" className="p-button-secondary"/>
                        <Button label="Grabar"/>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EdicionPosturaView);